import { useEffect, useState } from "react"
import { fetchPromptCatalog } from "@/shared/services/prompts"
import { Prompt } from "@/shared/types/prompt"

interface UsePromptCatalogResult {
  prompts: Prompt[]
  loading: boolean
  error: string | null
}

const usePromptCatalog = (): UsePromptCatalogResult => {
  const [prompts, setPrompts] = useState<Prompt[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    let cancelled = false

    const load = async () => {
      setLoading(true)
      setError(null)
      try {
        const data = await fetchPromptCatalog()
        if (cancelled) return
        setPrompts(data)
      } catch (err) {
        console.error("Error loading prompt catalog:", err)
        if (cancelled) return
        setError("Failed to load prompts")
      } finally {
        if (!cancelled) setLoading(false)
      }
    }

    load()
    return () => {
      cancelled = true
    }
  }, [])

  return { prompts, loading, error }
}

export { usePromptCatalog }
export type { UsePromptCatalogResult }
